import { Files } from '../../../lib/constants/files'
import { TeachingHall } from '../../../lib/types/models/ol/teaching-hall/teaching-hall'
import { TeachingHallInput } from '../../../lib/types/models/ol/teaching-hall/teaching-hall-input'
import { uploadFile } from '../../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createTeachingHall = async (input: TeachingHallInput & { olId: number }) => {
  const { olId, ...data } = input
  if (data.files)
    for (let i = 0; i < data.files.length; i++) {
      const newFile = await uploadFile(Files.TEACHING_HALL, data.files[i])
      if (newFile) data.files[i] = { ...newFile }
    }

  return restApiClient
    .url(constructApiUrl(API.ols.createTeachingHall.url, { olId }))
    .post<TeachingHall, TeachingHallInput>(data)
}
